import type { IInviteCodeRow } from './types';
import type { ICompanyInviteCodeRequest } from '@/types/request/company';
import type { ICompanyInviteCodeDetail } from '@/types/response/company';
import moment from 'moment';

export function toCompanyInviteCodesDto(
  rows: IInviteCodeRow[],
): ICompanyInviteCodeRequest[] {
  return [...rows]
    .filter(
      (r): r is IInviteCodeRow & { id: number } =>
        typeof r.id === 'number' && !Number.isNaN(r.id),
    )
    .sort((a, b) => a.id - b.id)
    .map((r) => ({
      code: r.code ?? null,
      validFrom: r.valid_from ?? null,
      validTo: r.valid_to ?? null,
      sortOrder: r.id,
      quantity: r.limit ?? null,
      cogEvo: r.cog_evo ?? null,
      nouknow: r.nounow ?? null,
    }));
}

export const toYYYYMMDD = (
  isoOrDate: string | null | undefined,
): string | null => {
  if (!isoOrDate) return null;
  const m = moment(String(isoOrDate));
  return m.isValid() ? m.format('YYYY-MM-DD') : null;
};

/** Map API detail inviteCodes -> UI row shape (snake_case) */
export function fromCompanyInviteCodesDetailToRows(
  inviteCodes: ICompanyInviteCodeDetail[],
): IInviteCodeRow[] {
  return [...inviteCodes]
    .sort((a, b) => (a.sortOrder ?? a.id) - (b.sortOrder ?? b.id))
    .map((c) => ({
      id: c.sortOrder ?? c.id,
      code: c.code ?? null,
      valid_from: toYYYYMMDD(c.validFrom),
      valid_to: toYYYYMMDD(c.validTo),
      cog_evo: c.cogEvo ?? null,
      nounow: c.nouknow ?? null,
      limit: c.quantity ?? null,
    }));
}

